// store/modules/readByUserId.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ReadByUserIdService } from "../../service/ReadByUserIdService";
const initialState = {
    userInfo: null,
    loading: false,
};
export const readReadByUserId = createAsyncThunk("readByUserId/read", async (_payload) => {
    const response = await ReadByUserIdService.read(_payload);
    return response.data;
});
const readByUserIdSlice = createSlice({
    name: "readByUserId",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(readReadByUserId.pending, (state) => {
            state.loading = true;
        })
            .addCase(readReadByUserId.fulfilled, (state, action) => {
            state.loading = false;
            state.userInfo = action.payload;
        })
            .addCase(readReadByUserId.rejected, (state) => {
            state.loading = false;
        });
    },
});
export const readByUserIdReducer = readByUserIdSlice.reducer;
export const readByUserIdActions = readByUserIdSlice.actions;
